export default "__VITE_ASSET__lhSfqq$1__"